import { AuthFetch, snakeCase, ScheduledJob, ScheduledJobModel } from '../gs-core/common';

export class JobService {
  private authFetch: AuthFetch;

  constructor(authFetch: AuthFetch) {
    this.authFetch = authFetch;
  }

  async findAll(): Promise<ScheduledJob[]> {
    const jobsJson = await this.authFetch('/api/job') as ScheduledJob[];

    return jobsJson.map(jobJson => ScheduledJobModel.create(jobJson));
  }

  async run(job: ScheduledJob) {
    const jobNameNormalized = snakeCase(job.name);

    return await this.authFetch(`/api/job/${jobNameNormalized}`, { method: 'POST' });
  }
}



// WEBPACK FOOTER //
// ./src/services/JobService.ts